import CaptureTips from './CaptureTips';

export default CaptureTips;
